import { render, staticRenderFns } from "./BookReview.vue?vue&type=template&id=5794a01e&scoped=true"
import script from "./BookReview.vue?vue&type=script&lang=js"
export * from "./BookReview.vue?vue&type=script&lang=js"
import style0 from "./BookReview.vue?vue&type=style&index=0&id=5794a01e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5794a01e",
  null
  
)

export default component.exports